<template>
  <div class="tw:animate-pulse">
    <div class="tw:rounded-lg tw:bg-gray-300" :style="{ height }" />
  </div>
</template>
<script setup>
defineProps({
  height: {
    type: String,
    default: '150px',
  },
})
</script>
